export default (axios, { publicId, description }) => axios.post('/self-employed/declare', { publicId, description });
